import { render, staticRenderFns } from "./addServiceComponent.vue?vue&type=template&id=cfc05d1c&scoped=true"
import script from "./addServiceComponent.vue?vue&type=script&lang=js"
export * from "./addServiceComponent.vue?vue&type=script&lang=js"
import style0 from "./addServiceComponent.vue?vue&type=style&index=0&id=cfc05d1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc05d1c",
  null
  
)

export default component.exports